export default {
    methods: {
        subscribeToStore(subscribedTo) {
            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'setIsAppView' && subscribedTo.includes('isAppView')) {
                    this.isAppView = state.isAppView
                }
                else if (mutation.type === 'setAddOns' && subscribedTo.includes('addOns')) {
                    this.addOns = state.addOns
                }
                else if (mutation.type === 'setCcInfo' && subscribedTo.includes('ccInfo')) {
                    this.ccInfo = state.ccInfo
                }
                else if (mutation.type === 'setShowManagePlanDialog' && subscribedTo.includes('showManagePlanDialog')) {
                    this.showManagePlanDialog = state.showManagePlanDialog
                }
                else if (mutation.type === 'setPlanDetails' && subscribedTo.includes('planDetails')) {
                    this.planDetails = state.planDetails
                }
                else if (mutation.type === 'setNextPayment' && subscribedTo.includes('nextPayment')) {
                    this.nextPayment = state.nextPayment
                }
                else if (mutation.type === 'setClients' && subscribedTo.includes('clients')) {
                    this.clients = state.clients
                }
                else if (mutation.type === 'setReferralProgram' && subscribedTo.includes('referralProgram')) {
                    this.referralProgram = state.referralProgram
                }
                else if (mutation.type === 'setUser' && subscribedTo.includes('user')) {
                    this.user = state.user
                }
                else if (mutation.type === 'setShowUpdateCcDialog' && subscribedTo.includes('showUpdateCcDialog')) {
                    this.showUpdateCcDialog = state.showUpdateCcDialog
                }
                else if (mutation.type === 'setDeclinedPayment' && subscribedTo.includes('declinedPayment')) {
                    this.declinedPayment = state.declinedPayment
                }
                else if (mutation.type === 'setShowSuccessDialog' && subscribedTo.includes('showSuccessDialog')) {
                    this.showSuccessDialog = state.showSuccessDialog
                }
                else if (mutation.type === 'setBillingHistory' && subscribedTo.includes('billingHistory')) {
                   this.billingHistory = state.billingHistory
                }
                else if (mutation.type === 'setShowPayDialog' && subscribedTo.includes('showPayDialog')) {
                    this.showPayDialog = state.showPayDialog
                }
                else if (mutation.type === 'setPlanToConfirm' && subscribedTo.includes('planToConfirm')) {
                   this.planToConfirm = state.planToConfirm
                }
                else if (mutation.type === 'setShowConfirmDialog' && subscribedTo.includes('showConfirmDialog')) {
                    this.showConfirmDialog = state.showConfirmDialog
                }
                else if (mutation.type === 'setShowConfirmPurchaseDialog' && subscribedTo.includes('showConfirmPurchaseDialog')) {
                    this.showConfirmPurchaseDialog = state.showConfirmPurchaseDialog
                }
                else if (mutation.type === 'setReferenceBookCart' && subscribedTo.includes('referenceBookCart')) {
                    this.referenceBookCart = state.referenceBookCart
                }
                else if (mutation.type === 'setShowReferenceBooksDialog' && subscribedTo.includes('showReferenceBooksDialog')) {
                    this.showReferenceBooksDialog = state.showReferenceBooksDialog
                }
                else if (mutation.type === 'setInitialUrlParameters' && subscribedTo.includes('initialUrlParameters')) {
                    this.initialUrlParameters = state.initialUrlParameters
                }
                else if (mutation.type === 'setPlusOneClients' && subscribedTo.includes('plusOneClients')) {
                    this.plusOneClients = state.plusOneClients
                }
                else if (mutation.type === 'setShowCustomerSupportDialog' && subscribedTo.includes('showCustomerSupportDialog')) {
                    this.showCustomerSupportDialog = state.showCustomerSupportDialog
                }
            })
        },
    }
};
